<div class="wrap">
<h1>Please SignUp Here!</h1><br/>
<p style="color:red;" *ngIf = "passwordFlag">Password And Confirm Password are not same!</p><br/>
<p style="color:green;" *ngIf = "signUpFlag">Successfully Added, Please Close the popUp and Login To continue!</p><br/>

<form #f="ngForm">
    <div class="form-group row">
        <label for="inputfirstName" class="col-sm-2 col-form-label">First Name</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" [(ngModel)]="signUp.firstName" name="fname" id="inputfirstName" placeholder="First Name" required>
        </div>
    </div>
    <div class="form-group row">
        <label for="inputlastName" class="col-sm-2 col-form-label">Last Name</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" [(ngModel)]="signUp.lastName" name="lname" id="inputlastName" placeholder="Last Name" required>
        </div>
    </div>
    <div class="form-group row">
      <label for="inputEmail3" class="col-sm-2 col-form-label">Email</label>
      <div class="col-sm-10">
        <input type="email" class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" title="Please enter valid email like [test@test.com]." [(ngModel)]="signUp.email" name="email" id="inputEmail3" placeholder="Email" required>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputPassword3" class="col-sm-2 col-form-label">Password</label>
      <div class="col-sm-10">
        <input [type]="show_password ? 'text' : 'password'" class="form-control" name="pass" [(ngModel)]="signUp.password" id="inputPassword3" placeholder="Password" required>
      </div>
    </div>
    <input type="checkbox" (change)="myFunction('hj')"><span> Show Password</span><br/><br/>
    <div class="form-group row">
        <label for="inputconfirmPassword3" class="col-sm-2 col-form-label">Confirm Password</label>
        <div class="col-sm-10">
          <input [type]="show_confirm_password ? 'text' : 'password'" class="form-control" name="cpass" [(ngModel)]="signUp.confirmPassword" id="inputconfirmPassword3" placeholder="Confirm Password" required>
        </div>
    </div>
    <input type="checkbox" (change)="myFunction('confirm')"><span> Show Confirm Password</span><br/><br/>
  </form>
  <div class="col-sm-10">
    <button type="button" style="float: left;" class="btn btn-primary" (click)="dialogRef.close()">
      Close
  </button>
    <button type="button" style="float: right;" class="btn btn-primary" [disabled]="!f.valid" (click) = "saveUser()">Sign Up</button>
  </div>
</div>